import { NavLink } from "react-router-dom";
import { ArrowLeft, Calculator, History, Settings } from "lucide-react";

const NAV = [
  { to: "/", label: "Calculator", icon: Calculator, id: "nav-calculator" },
  { to: "/history", label: "History", icon: History, id: "nav-history" },
  { to: "/settings", label: "Settings", icon: Settings, id: "nav-settings" },
];

export const AppShell = ({ children }) => (
  <div className="shell">
    <header className="topbar" data-testid="app-header">
      <div className="brand">
        <img className="brand-logo" src="/logo-mark.png" alt="POWER PROFIT logo" data-testid="header-logo" />
        <span className="brand-name">POWER PROFIT</span>
      </div>
      <div className="topbar-right">
        <span className="privacy-pill" data-testid="privacy-indicator">Inputs stay on device</span>
        <a className="back-link" href="https://boatrvmoving.com/app/driver" data-testid="back-to-brv-link">
          <ArrowLeft size={14} strokeWidth={2.5} />
          <span className="back-full">Back to Boat RV Moving</span>
          <span className="back-short">BRV</span>
        </a>
      </div>
    </header>
    <main className="page">{children}</main>
    <nav className="bottomnav" data-testid="bottom-nav">
      {NAV.map(({ to, label, icon: Icon, id }) => (
        <NavLink key={to} to={to} end data-testid={id} className={({ isActive }) => `navitem ${isActive ? "active" : ""}`}>
          <Icon size={20} />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  </div>
);
